import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './Components/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SearchPage from './Components/SearchPage';
import Header from './Components/Header';

function App() {

return(
  <>
 <BrowserRouter>
 <Header/>
 <Routes>
<Route path='/' element={<HomePage/>}/>
<Route path='/productConfigurator' element={<SearchPage/>}/>
 </Routes>
 </BrowserRouter>
  </>
)

}
  

export default App;
